/* Grouped-view indent: nested cards under an app group header sit
 * 8px further in so the hierarchy reads visually. Same pattern as
 * NotificationListItem/styles.module.css. */
.indent {
  padding-left: var(--spacing-8);
}

/* Inline reply feedback — rendered inside the replySlot below the
 * ReplyComposer. Intentionally small and unobtrusive so it doesn't
 * compete with the composer. Uses --text-size-xs to match the
 * NotificationListItem reply status text. */
.replyFeedbackOk {
  display: block;
  font-family: var(--font-family);
  font-size: var(--text-size-xs);
  line-height: var(--text-lh-xs);
  color: var(--text-success);
}

.replyFeedbackErr {
  display: block;
  font-family: var(--font-family);
  font-size: var(--text-size-xs);
  line-height: var(--text-lh-xs);
  color: var(--text-negative);
}

/* Exit animation — shared with NotificationListItem via composes so
 * both card types animate identically and a single token change in
 * shared/dismissing.module.css updates all dismiss animations at once. */
.dismissing {
  composes: dismissing from "../../shared/dismissing.module.css";
}
